import { z } from 'zod';

export enum FilterTypeEnum {
  Dropdown = 1,
  DateRange = 2,
  Autocomplete = 3,
  UserTerritory = 4,
}

// Core interface types for client use
export interface FilterItemValue {
  key: string;
  value: string;
}

export interface FilterItem {
  id: number;
  identifier: string;
  label: string;
  type: FilterTypeEnum;
  operators: string[];
  data: FilterData;
}

// Basic Zod schemas for validation
export const FilterItemSchema = z.object({
  key: z.string(),
  value: z.string(),
});

export const DropdownFilterDataSchema = z.object({
  items: z.array(FilterItemSchema),
});

export const AutocompleteFilterDataSchema = z.object({
  endpoint: z.url(),
});

export const UserTerritoryFilterDataSchema = z.object({});

export const FilterDataSchema = z.union([
  DropdownFilterDataSchema,
  AutocompleteFilterDataSchema,
  UserTerritoryFilterDataSchema,
]);

const FilterDataSchemaMap = {
  [FilterTypeEnum.Dropdown]: DropdownFilterDataSchema,
  [FilterTypeEnum.DateRange]: DropdownFilterDataSchema,
  [FilterTypeEnum.Autocomplete]: AutocompleteFilterDataSchema,
  [FilterTypeEnum.UserTerritory]: UserTerritoryFilterDataSchema,
};
export type FilterData<T extends FilterTypeEnum = FilterTypeEnum> =
  T extends FilterTypeEnum.Dropdown ? z.infer<typeof DropdownFilterDataSchema>
  : T extends FilterTypeEnum.DateRange ? z.infer<typeof DropdownFilterDataSchema>
  : T extends FilterTypeEnum.Autocomplete ? z.infer<typeof AutocompleteFilterDataSchema>
  : T extends FilterTypeEnum.UserTerritory ? z.infer<typeof UserTerritoryFilterDataSchema>
  : z.infer<typeof FilterDataSchema>;

export type FilterItemZod = z.infer<typeof FilterItemSchema>;
export type FilterDataZod = z.infer<typeof FilterDataSchema>;

// Utility function for parsing filter data
export function parseFilterData(data: unknown, type: FilterTypeEnum): FilterData {
  const schema = FilterDataSchemaMap[type];

  const parseResult = schema.safeParse(data);

  if (!parseResult.success) {
    if (type === FilterTypeEnum.UserTerritory) {
      return {};
    }
    return { items: [] };
  } else {
    return parseResult.data;
  }
}
